import { useGetVehicleClasses } from '@/clients/vehicleClasses/vehicleClasses.ts';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useMarketContext } from '@/shared/context/MarketContext.tsx';

export const useVehicleClasses = () => {
    const { marketCode } = useMarketContext();
    const { getVehicleClasses } = useGetVehicleClasses();

    return useSuspenseQuery({
        queryKey: ['vehicle-classes'],
        queryFn: async () => await getVehicleClasses(),
        refetchOnWindowFocus: false,
        select: vehicleClasses =>
            vehicleClasses
                .filter(vehicleClass => vehicleClass.marketUsage.includes(marketCode))
                .map(vehicleClass => ({
                    ...vehicleClass,
                    // we convert the payload values from "KG" to "TON"
                    payloadInTons: vehicleClass.payload / 1000,
                })),
    });
};
